module.exports = __webpack_public_path__ + "img/NikitaKeshav.bc6bff9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/NikitaKeshav.jpeg
// module id = 1705
// module chunks = 1